import { Action } from 'redux';
// Import States.
import {
	AppState,
	PolicyState,
} from '@app/redux/states';
// Import Actions.
import {
	LoadPolicyNoteEmailsAction,
} from '@app/redux/actions';
// Import state initializers.
import {
	initializePolicyState
} from '@app/redux/reducers/initializers';
// Import state queries.
import {
	queryPolicyState,
} from '@app/redux/reducers/queries';
// Import api models.
import {
	PolicyNoteEmail
} from '@app/models/api';


// Load Policy Note Emails Reducer.

let LoadPolicyNoteEmailsReducer = (state: AppState, action: Action): AppState => {
	let loadPolicyNoteEmailsAction: LoadPolicyNoteEmailsAction = action as LoadPolicyNoteEmailsAction;
	let policyNoteEmails: PolicyNoteEmail[] = loadPolicyNoteEmailsAction.policyNoteEmails;

	// Create copy of the of app state.
	let newState: AppState = initializePolicyState(state, loadPolicyNoteEmailsAction);

	// Query the state.
	let policyState: PolicyState = queryPolicyState(newState, loadPolicyNoteEmailsAction);

	policyState.policyNoteEmails = policyNoteEmails;
	policyState.arePolicyNoteEmailsLoaded = true;

	return newState;
}

// Export reducers.
export {
	LoadPolicyNoteEmailsReducer,
};